import axios from 'axios';

// Shared axios instance + interceptors for the whole app. Extracted from the
// former monolithic services/api.js so per-domain API modules
// (services/<domain>/api.js) can all import ONE client with the auth header +
// 401 handling already wired. services/api.js now re-exports everything from
// here and the domain modules (a barrel), so existing imports keep working.

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// 24-hex ObjectId guard, used across domains to skip malformed ids before
// hitting the API. Lives here (not in a domain file) because it's cross-cutting.
const MONGO_ID_RE = /^[a-f\d]{24}$/i;
export const isMongoId = (id) => id && MONGO_ID_RE.test(id);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000, // 60 second timeout for large payloads
  maxContentLength: 10 * 1024 * 1024, // 10MB max content length
  maxBodyLength: 10 * 1024 * 1024, // 10MB max body length
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
